import { render } from "./RadarChart.vue?vue&type=template&id=6ff4be28"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__